import clsx from 'clsx';
import { ReactComponent as TrustedShopVerifiedBadge } from '../assets/trusted-shop-verified.svg';
import { TRUSTED_SHOPS_FEEDBACK_URL } from '../config';
import { TrustedShopsStarRating } from '../TrustedShopsStarRating/TrustedShopsStarRating';
import { getReviewA11yLabel } from '../utils';
import type { TrustedShopReview } from './hooks/useTrustedShopsReviews';
import styles from './TrustedShopsWidget.module.scss';
import { formatReviewDateRelative } from './utils';

const scrollFocusedCardIntoView = (e: React.FocusEvent<HTMLElement>) => {
  e.currentTarget.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'nearest',
  });
};

export const TrustedShopsReviewCard = ({
  review,
}: {
  review: TrustedShopReview;
}) => (
  <a
    href={TRUSTED_SHOPS_FEEDBACK_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={clsx(styles.tile, styles.reviewCard)}
    tabIndex={0}
    onFocus={scrollFocusedCardIntoView}
  >
    <div className={styles.header}>
      <TrustedShopsStarRating
        rating={review.rating}
        aria-label={getReviewA11yLabel(review.rating, review.customerShortName)}
      />
      {review.isVerified && (
        <span
          className={styles.verifiedIcon}
          aria-label="Verifizierte Bewertung"
        >
          <TrustedShopVerifiedBadge aria-hidden="true" />
        </span>
      )}
    </div>
    <div className={styles.meta}>
      {formatReviewDateRelative(review.date)} von {review.customerShortName}
    </div>
    {review.title &&
      review.comment &&
      !review.comment.startsWith(review.title) && (
        <div className={styles.reviewTitle}>{review.title}</div>
      )}
    <div className={styles.comment}>{review.comment}</div>
  </a>
);
